import { useCallback, useState } from 'react'
import { Bell, Eye, EyeOff } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const fmtAgo = (iso) => {
  if (!iso) return '—'
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000)
  if (s < 60) return `${s}s`
  if (s < 3600) return `${Math.round(s/60)}m`
  if (s < 86400) return `${Math.round(s/3600)}u`
  return `${Math.round(s/86400)}d`
}

const kleurVoorLevel = (l) => l === 'critical' ? '#FF5A5A' : l === 'warning' ? '#FFB57A' : '#B4FF39'

export default function AdminBroadcastsScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermBroadcasts(); setD(r.data)
  }, [])
  const recent = d?.recent ?? []

  return (
    <AdminScreenShell title="Broadcasts" subtitle="Wat is er recent naar deelnemers gestuurd"
                      icon={Bell} refreshMs={30_000} onRefresh={load}>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <Tegel label="Verzonden 24u" waarde={d?.laatste24u ?? 0} kleur="#B4FF39" groot />
        <Tegel label="Nog niemand gelezen" waarde={d?.ongelezenTotaal ?? 0}
               kleur={d?.ongelezenTotaal > 0 ? '#FFB57A' : '#61E294'} />
        <Tegel label="Getoond" waarde={recent.length} sub="recente broadcasts" kleur="#B4FF39" />
      </div>

      <div className="rounded-[6px] border border-border bg-card p-4">
        <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
          Recente broadcasts
        </h2>
        {recent.length === 0 ? (
          <div className="text-muted-foreground text-sm">Nog geen broadcasts.</div>
        ) : recent.map(n => {
          const pct = n.totaal_users ? Math.round(100 * n.gelezen / n.totaal_users) : 0
          const Icon = pct === 100 ? Eye : EyeOff
          return (
            <div key={n.id} className="mb-3 pb-3 border-b border-border/40 last:border-0"
                 style={{ borderLeft: `3px solid ${kleurVoorLevel(n.level)}`, paddingLeft: '8px' }}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="text-base font-bold">{n.title}</div>
                  {n.body && <div className="text-sm text-muted-foreground line-clamp-2">{n.body}</div>}
                  <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-1">
                    {fmtAgo(n.created_at)} geleden · {n.level ?? 'info'}
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <Icon className="h-4 w-4 inline mr-1"
                        style={{ color: pct === 100 ? '#61E294' : '#FFB57A' }} />
                  <span className="font-mono text-sm">{n.gelezen}/{n.totaal_users}</span>
                  <div className="font-mono text-[10px] text-muted-foreground">{pct}%</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </AdminScreenShell>
  )
}
